<template>
	<div id="fondo" class="fullH">
		<v-row align="center" justify="center" class="fullH" no-gutters>
			<v-col xs="12 " sm="6">
				<div align="center">
					<v-icon color="white" size="170">mdi-school</v-icon>
				</div>
				<!-- Logo + Titulo -->
				<div id="login_logo">
					<span>CENTRO+</span><br />
					<span>INGENIERÍA</span><br />
				</div>
				<br />
				<!-- Boton google -->
				<div>
					<v-col xs="8">
						<v-btn id="login_btn" depressed block @click="iniciarSesion"
							><v-icon>mdi-gmail</v-icon> Iniciar con correo UCAB</v-btn
						>
					</v-col>
				</div>

				<br />
				<br />
				<br />
				<br />
			</v-col>
		</v-row>
		<v-snackbar v-model="snackbar" :timeout="4000">
			¡Debe utlizar correo UCAB!
			<v-btn text @click="snackbar = false">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-snackbar>

		<!-- MODAL INSTAGRAM -->
		<v-dialog v-model="dialog" persistent>
			<v-card align="center">
				<v-card-title class="headline">Instagram</v-card-title>

				<v-card-text align="center" class="black--text mt-2">
					Accede a <strong>Centro+</strong> utilizando tu navegador favorito.
					<ol class="text-left">
						<li>
							Selecciona en los <v-icon color="primary">mdi-dots-vertical</v-icon> (3
							puntos)
						</li>
						<li>
							<strong>"Abrir con"</strong> para abrir con tu naveador de preferencia
						</li>
					</ol>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { auth, provider } from "@/firebase";
import store from "../store/index";

export default {
	data: () => {
		return {
			snackbar: false,
			dialog: false
		};
	},
	methods: {
		iniciarSesion() {
			auth.signInWithPopup(provider)
				.then(result => {
					// This gives you a Google Access Token. You can use it to access the Google API.
					//let token = result.credential.accessToken;

					let user = result.user;
					//console.warn("USUARIO: ", token, user);

					//this.iniciarSesionUsuario(user);

					if (user.email.includes("ucab.edu.ve")) {
						store.dispatch("iniciarSesionUsuario", user);
						this.$ua.trackEvent(`CplusInteraccion`, "Login", "Correo UCAB");
					} else {
						//POPUP ERROR AND LOGOUT
						//console.error("CORREO NO UCAB");
						this.snackbar = true;
						auth.signOut()
							.then(function() {
								// Sign-out successful.
								//console.log("BYE BYE OK");
							})
							.catch(function(error) {
								// An error happened.
								console.log(error);
							});

						this.$ua.trackEvent(`CplusInteraccion`, "Login", "Correo NO UCAB");
					}
				})
				.catch(error => {
					// Handle Errors here.
					var errorCode = error.code;
					var errorMessage = error.message;
					var email = error.email;
					var credential = error.credential;
					console.error(errorCode, errorMessage, email, credential);

					this.$ua.trackEvent(`CplusInteraccion`, "Login", `ERROR ${errorCode}`);
				});
		}
	},
	mounted() {
		let ua = navigator.userAgent || navigator.vendor || window.opera;
		let isInstagram = ua.indexOf("Instagram") > -1 ? true : false;

		if (isInstagram) {
			this.dialog = true;
		}
	}
};
</script>

<style scoped>
div#fondo {
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	background-image: url("../assets/fondoINGDegradado.jpg");
}

.fullH {
	height: 100vh;
}

#login_logo {
	font-family: Roboto;
	font-style: normal;
	font-weight: bold;
	font-size: 24px;
	line-height: 28px;
	text-align: center;

	color: #ffffff;

	text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

#login_btn {
	color: #005e1c;
}
</style>
